import { StWcFeedback } from '@stilingue/st-auth-feedback';
/**
 * @file holds authorization and authentication utilities as the default options.
 * @module utils
 *
 * @author Hugo Azevedo
 */

/**
 * Default function used as callback of an unauthenticated request or login expired.
 * @param {axios.err}
 * @returns {axios.err}
 */
export function unauthorizedLogin(err) {
  invalidSessionFeedback();
  return err;
}

/** Default function used as callback of an unauthorized requests or access denied.
 * @param {axios.err}
 * @returns {axios.err}
 */
export function accessDenied(err) {
  return err;
}

/** Default function used as callback of an auth token not found on a request.
 * @param {axios.request}
 * @returns {boolean} true if should continue with a request, false otherwise.
 */
export function authNotFound() {
  invalidSessionFeedback();
  return false;
}

/** Default map of status/conditinos to callbacks.
 * Override this object using de defaultsProvider in your project to customize it.
 * If you wish to add a custom behaviour on a 404 error, you can use it in this way:
 * @example
 * const errorStatusInterceptors = {
 *   404: console.error,
 *   500: makeAnotherRequest
 *   ...:
 *   401: logoutUser
 * }
 * StRequests.defaults.use({errorStatusInterceptors})
 * @constant
 * @default
 */
export const errorStatusInterceptors = {
  401: unauthorizedLogin,
  403: accessDenied,
  authNotFound,
};

function invalidSessionFeedback() {
  try {
    registerAuthFeedback();
    feedback();
  } catch (e) {
    console.error(e);
  }
}

function registerAuthFeedback() {
  try {
    if (!window.customElements.get('st-wc-auth-feedback')) {
      window.customElements.define('st-wc-auth-feedback', StWcFeedback);
    }
  } catch (e) {
    console.error(e);
  }
}

function feedback(data) {
  let el = document.querySelector('st-wc-auth-feedback');
  if (el) {
    if (el.active) {
      return el;
    }

    el.authenticated = false;
    el.active = true;
    return el;
  }

  el = document.createElement('st-wc-auth-feedback', { ...data });
  document.body.append(el);
  return el;
}
